import React, { Component } from "react";
import { connect } from "react-redux";
import { addEvaluationB } from "../../../../stores/actions/evaluationBAction";
import { Editor, EditorState, convertToRaw, convertFromRaw, RichUtils } from "draft-js";
import 'draft-js/dist/Draft.css';

class NewSchemeQuestionnaire extends Component {
    constructor(props) {
        super(props);
        this.selectRef = React.createRef();
        this.state = {
            question: '',
            selectedCriteria: '',
            selectedSchemes: [],
            createdDate: '',
            createdBy: '',
            answers: [],
            descriptions: {},

            getQuestionDescription: EditorState.createEmpty(),

            getAnswerContent: '',
            getAnswerMark: null,
            getAnswerStatus: null,
            getAnswerReview: EditorState.createEmpty(),
            getAnswerRef: '',

            hasDescription: false,
            isLoading: null,

        }

        this.baseState = this.state;
    }


    componentDidMount() {

        if (this.props.onMountRegister) {//returns true since prop 
            this.props.onMountRegister(this.resetState);
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        const { addEvaluationBError, addEvaluationBSuccess } = this.props;


        if (prevProps.addEvaluationBError !== addEvaluationBError) {
            this.setState({
                isLoading: false,
                message: {
                    msg: addEvaluationBError.message,
                    type: addEvaluationBError.type,
                }
            })
        }

        if (prevProps.addEvaluationBSuccess !== addEvaluationBSuccess) {
            this.setState({
                isLoading: false,
                message: {
                    msg: addEvaluationBSuccess.message,
                    type: addEvaluationBSuccess.type,
                }
            })
            setTimeout(() => {
                this.setState(this.baseState)
                this.props.hideModal_newQuestion();
            }, 2000);
        }
    }

    isFormInvalid = () => {
        const { getAnswerContent, getAnswerMark, getAnswerRef, getAnswerReview, getAnswerStatus } = this.state;

        const reviewText = getAnswerReview.getCurrentContent().getPlainText();

        return (
            !getAnswerContent.trim() || //also check for whitespace-only strings
            getAnswerMark === null ||
            getAnswerStatus === null ||
            !reviewText.trim() ||
            !getAnswerRef.trim()
        );
    }

    renderRichText = (rawContent) => {
        try {
            const contentState = convertFromRaw(rawContent);
            const editorState = EditorState.createWithContent(contentState);

            return (
                <div style={{ border: '1px solid #ddd', padding: '8px', backgroundColor: '#f9f9f9', minHeight: '30px' }}>
                    <Editor editorState={editorState} readOnly={true} onChange={() => { }} style={{ cursor: 'default' }} />
                </div>
            )
        } catch (error) {
            return <span style={{ cursor: 'default' }}>
                {JSON.stringify(rawContent)}
            </span>;
        }
    }

    saveAnswer = () => {

        const { getAnswerContent, getAnswerMark, getAnswerReview, getAnswerStatus, getAnswerRef } = this.state;

        const reviewRawContent = convertToRaw(getAnswerReview.getCurrentContent());

        this.setState({
            answers: [
                ...this.state.answers, {
                    text: getAnswerContent,
                    score: isNaN(parseInt(getAnswerMark)) ? null : parseInt(getAnswerMark),
                    status: getAnswerStatus,
                    review: reviewRawContent,
                    reference: getAnswerRef
                }],
            getAnswerContent: '',
            getAnswerMark: null,
            getAnswerReview: EditorState.createEmpty(),
            getAnswerStatus: null,
            getAnswerRef: ''

        });
    }

    onReviewChange = getAnswerReview => {
        this.setState({ getAnswerReview });
    }


    handleDateCreated = () => {
        const date = new Date();
        const createdAt = date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            timeZone: 'Asia/Singapore'
        }) + ' at ' + date.toLocaleTimeString('en-GB', {
            hour12: false,
            timeZone: 'Asia/Singapore'
        }) + ' UTC+8';

        this.setState({ createdDate: createdAt })
    }

    handleQuestionAuthor = () => {
        const { profile } = this.props;

        this.setState({
            createdBy: profile.userId
        })
    }

    handleSchemeSelection = (event) => {
        const selectedSchemeId = event.target.value;

        if (!selectedSchemeId) return;

        const { schemes } = this.props;
        const selectedScheme = schemes.find(scheme => scheme.id === selectedSchemeId);

        if (!selectedScheme) return;

        const schemeSubset = {
            id: selectedScheme.id,
            name: selectedScheme.name,
            code: selectedScheme.code
        };

        this.setState(prevState => ({
            selectedSchemes: [...prevState.selectedSchemes, schemeSubset]
        }), () => {
            this.selectRef.current.value = "";
        });
    }

    handleSelectedSchemeDelete = (schemeId) => {
        this.setState(prevState => ({
            selectedSchemes: prevState.selectedSchemes.filter(scheme => scheme.id !== schemeId)
        }));
    }

    removeAnswer = (id) => {
        let removedAnswer = this.state.answers.filter(ans => {//return an array that have id that is not the same as selected answer id
            return ans.id !== id
        });
        this.setState({
            answers: removedAnswer,

        });
    }

    addQuestion = () => {
        var result = window.confirm("Confirm Add");
        if (result) {
            this.handleAddDescription();
            const date = new Date();
            const createdAt = date.toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
                timeZone: 'Asia/Singapore'
            }) + ' at ' + date.toLocaleTimeString('en-GB', {
                hour12: false,
                timeZone: 'Asia/Singapore'
            }) + ' UTC+8';

            const { profile } = this.props;

            this.setState({
                isLoading: true,
                createdDate: createdAt,
                createdBy: profile.userId
            }, () => {
                this.props.addEvaluationB(this.state);
            });
        }
    }

    onDescriptionChange = (getQuestionDescription) => {
        this.setState({ getQuestionDescription });
    }

    handleDescriptionToggle = () => {
        this.setState({
            hasDescription: !this.state.hasDescription,
            getQuestionDescription: EditorState.createEmpty()
        });
    }

    handleAddDescription = () => {
        const { getQuestionDescription } = this.state;
        const descriptionRawContent = convertToRaw(getQuestionDescription.getCurrentContent());

        if (getQuestionDescription.getCurrentContent().getPlainText().trim()) {
            this.setState({
                descriptions: descriptionRawContent,
            });
        }
    }


    handleCriteriaChange = (event) => {
        const selectedId = event.target.value;

        if (selectedId) {
            const foundCriteria = this.props.criteria.find(c => c.id === selectedId);
            const selectedCriteria = { id: foundCriteria.id, name: foundCriteria.name }
            this.setState({ selectedCriteria });
        } else {
            this.setState({ selectedCriteria: null });
        }
    }

    _onBoldClick = (editorState, changeHandler) => {
        changeHandler(RichUtils.toggleInlineStyle(editorState, 'BOLD'));
    }

    _onItalicClick = (editorState, changeHandler) => {
        changeHandler(RichUtils.toggleInlineStyle(editorState, 'ITALIC'));
    }

    _onUnderlineClick = (editorState, changeHandler) => {
        changeHandler(RichUtils.toggleInlineStyle(editorState, 'UNDERLINE'));
    }

    handleKeyCommand = (command, editorState, changeHandler) => {
        const newState = RichUtils.handleKeyCommand(editorState, command);
        if (newState) {
            changeHandler(newState);
            return 'handled';
        }
        return 'not-handled';
    }

    resetState = () => {//reset all state bila 'X' is clicked
        this.setState({
            question: '',
            selectedCriteria: '',
            selectedSchemes: [],
            createdDate: '',
            createdBy: '',
            answers: [],
            descriptions: {},

            getQuestionDescription: EditorState.createEmpty(),

            getAnswerContent: '',
            getAnswerMark: null,
            getAnswerStatus: null,
            getAnswerReview: EditorState.createEmpty(),
            getAnswerRef: '',
        })
    }

    render() {
        const { selectedSchemes, answers, hasDescription, getQuestionDescription } = this.state;
        const { schemes, criteria } = this.props;

        const availableSchemes = schemes ? schemes.filter(scheme =>
            !selectedSchemes.some(selected => selected.id === scheme.id)
        ) : [];

        // console.log(this.props)

        return (
            <div>
                <b className="uppercase middle"> Add new question
                    <div className="title-border"></div>
                </b>
                <p>
                    <b>Question:</b>
                    <input type="text" className="col-md-12 form-control" placeholder="Question" value={this.state.question} onChange={(event) => this.setState({ question: event.target.value })} />
                    <input type="checkbox" checked={hasDescription} onChange={this.handleDescriptionToggle} /> Description
                </p>
                {hasDescription ? (
                    <div style={{ backgroundColor: '#eeeeee', padding: '10px' }}>
                        <div className="col-md d-flex align-items-center justify-content-start" style={{ marginBottom: '10px', paddingBottom: '5px' }}>
                            <button
                                type="button"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => this._onBoldClick(getQuestionDescription, this.onDescriptionChange)}
                                style={{
                                    fontWeight: getQuestionDescription.getCurrentInlineStyle().has('BOLD') ? 'bold' : 'normal',
                                    marginRight: '5px',
                                    padding: '5px 10px',
                                    border: '1px solid #ccc',
                                    backgroundColor: this.state.getQuestionDescription.getCurrentInlineStyle().has('BOLD') ? '#e6f3ff' : 'white',
                                    cursor: 'pointer'
                                }}
                            >
                                <strong>B</strong>
                            </button>
                            <button
                                type="button"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => this._onItalicClick(getQuestionDescription, this.onDescriptionChange)}
                                style={{
                                    fontStyle: getQuestionDescription.getCurrentInlineStyle().has('ITALIC') ? 'italic' : 'normal',
                                    marginRight: '5px',
                                    padding: '5px 10px',
                                    border: '1px solid #ccc',
                                    backgroundColor: getQuestionDescription.getCurrentInlineStyle().has('ITALIC') ? '#e6f3ff' : 'white',
                                    cursor: 'pointer'
                                }}
                            >
                                <em>I</em>
                            </button>
                            <button
                                type="button"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => this._onUnderlineClick(this.state.getQuestionDescription, this.onDescriptionChange)}
                                style={{
                                    textDecoration: getQuestionDescription.getCurrentInlineStyle().has('UNDERLINE') ? 'underline' : 'normal',
                                    marginRight: '5px',
                                    padding: '5px 10px',
                                    border: '1px solid #ccc',
                                    backgroundColor: getQuestionDescription.getCurrentInlineStyle().has('UNDERLINE') ? '#e6f3ff' : 'white',
                                    cursor: 'pointer'
                                }}
                            >
                                <u>U</u>
                            </button>
                        </div>
                        <div className="col-md d-flex align-items-center justify-content-center">
                            <div style={{ border: '1px solid #ccc', minHeight: '50px', padding: '10px', flexGrow: 1, backgroundColor: 'white' }}>
                                <Editor
                                    editorState={getQuestionDescription}
                                    onChange={this.onDescriptionChange}
                                    handleKeyCommand={(command) => this.handleKeyCommand(command, getQuestionDescription, this.onDescriptionChange)}
                                    placeholder="Description"
                                />
                            </div>
                        </div>

                    </div>
                ) : ('')}

                <p>{/*Select one only.*/}
                    <b>Selected Criteria</b>
                    <select className="form-control" value={this.state.selectedCriteria?.id || ""} onChange={this.handleCriteriaChange}>
                        <option value="">Choose Criteria</option>
                        {criteria && criteria.map((c, i) => (
                            <option key={i} value={c.id}>
                                {c.name}
                            </option>
                        ))}
                    </select>
                </p>
                <div style={{ paddingBottom: '15px' }}>
                    {/*Select multiple*/}
                    <b>Related Schemes</b>
                    <select ref={this.selectRef} className="form-control" onChange={this.handleSchemeSelection}>
                        <option value="">Choose Related Scheme&#40;s&#41;</option>
                        {availableSchemes.map((scheme, index) => {
                            return (
                                <option key={scheme.id} value={scheme.id}>
                                    {scheme.name} &#40;{scheme.code}&#41;
                                </option>
                            )
                        })}
                    </select>
                    <b>Selected Schemes</b>
                    {selectedSchemes && selectedSchemes.map((selectedScheme, index) => {
                        return (
                            <div key={selectedScheme.id} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ position: 'relative', left: '20px' }}>{selectedScheme.name} &#40;{selectedScheme.code}&#41;</div>
                                <span onClick={(event) => this.handleSelectedSchemeDelete(selectedScheme.id)}><i className="fa fa-trash text-red"></i></span>
                            </div>
                        )
                    })}
                </div>


                <div style={{ backgroundColor: '#eeeeee', padding: '10px' }}>
                    <div>
                        <b>Answer:</b>
                        <input type="text" className="form-control" value={this.state.getAnswerContent || ''} onChange={event => this.setState({ getAnswerContent: event.target.value })} placeholder="Answer" />
                    </div>
                    <div>
                        <b>Status:</b>
                        <select className="form-control" value={this.state.getAnswerStatus || ''} onChange={event => this.setState({ getAnswerStatus: event.target.value })}>
                            <option defaultValue>Choose Answer Status</option>
                            <option value={'Keperluan Belum Dipenuhi'}>Keperluan Belum Dipenuhi</option>
                            <option value={'Keperluan Belum Sepenuhnya Lengkap'}>Keperluan Belum Sepenuhnya Lengkap</option>
                            <option value={'Keperluan Telah Dipenuhi'}>Keperluan Telah Dipenuhi</option>
                        </select>
                    </div>
                    <div>
                        <b>Mark:</b>
                        <select className="col-md-5 form-control" value={this.state.getAnswerMark || ''} onChange={event => this.setState({ getAnswerMark: event.target.value })}>Mark:
                            <option defaultValue>Choose Mark Value</option>
                            <option value={0}>0 - Tiada</option>
                            <option value={1}>1 - Ada &#40;Tidak Lengkap&#41;</option>
                            <option value={2}>2 - Ada &#40;Separa Lengkap&#41;</option>
                            <option value={3}>3 - Ada &#40;Lengkap&#41;</option>
                        </select>
                    </div>
                    <div>
                        <b>Answer Review:</b>
                        <div style={{ marginBottom: '10px', paddingBottom: '5px' }}>
                            <button
                                type="button"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => this._onBoldClick(this.state.getAnswerReview, this.onReviewChange)}
                                style={{
                                    fontWeight: this.state.getAnswerReview.getCurrentInlineStyle().has('BOLD') ? 'bold' : 'normal',
                                    marginRight: '5px',
                                    padding: '5px 10px',
                                    border: '1px solid #ccc',
                                    backgroundColor: this.state.getAnswerReview.getCurrentInlineStyle().has('BOLD') ? '#e6f3ff' : 'white',
                                    cursor: 'pointer'
                                }}
                            >
                                <strong>B</strong>
                            </button>
                            <button
                                type="button"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => this._onItalicClick(this.state.getAnswerReview, this.onReviewChange)}
                                style={{
                                    fontStyle: this.state.getAnswerReview.getCurrentInlineStyle().has('ITALIC') ? 'italic' : 'normal',
                                    marginRight: '5px',
                                    padding: '5px 10px',
                                    border: '1px solid #ccc',
                                    backgroundColor: this.state.getAnswerReview.getCurrentInlineStyle().has('ITALIC') ? '#e6f3ff' : 'white',
                                    cursor: 'pointer'
                                }}
                            >
                                <em>I</em>
                            </button>
                            <button
                                type="button"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => this._onUnderlineClick(this.state.getAnswerReview, this.onReviewChange)}
                                style={{
                                    textDecoration: this.state.getAnswerReview.getCurrentInlineStyle().has('UNDERLINE') ? 'underline' : 'normal',
                                    marginRight: '5px',
                                    padding: '5px 10px',
                                    border: '1px solid #ccc',
                                    backgroundColor: this.state.getAnswerReview.getCurrentInlineStyle().has('UNDERLINE') ? '#e6f3ff' : 'white',
                                    cursor: 'pointer'
                                }}
                            >
                                <u>U</u>
                            </button>
                        </div>

                        <div style={{ border: '1px solid #ccc', minHeight: '100px', padding: '10px', backgroundColor: 'white' }}>
                            <Editor
                                editorState={this.state.getAnswerReview}
                                onChange={this.onReviewChange}
                                handleKeyCommand={(command) => this.handleKeyCommand(command, this.state.getAnswerReview, this.onReviewChange)}
                                placeholder="Review"
                            />
                        </div>
                    </div>
                    <div>
                        <b>Answer Reference:</b>
                        <textarea name="" className="form-control" value={this.state.getAnswerRef || ''} onChange={event => this.setState({ getAnswerRef: event.target.value })} placeholder="Reference"></textarea>
                    </div>

                    <button style={{ border: 'none' }} disabled={this.isFormInvalid()} className={this.isFormInvalid() ? "badge bg-lightBlue text-white" : "badge bg-blue text-white"} onClick={this.saveAnswer.bind(this)}>Save and Add New Answer</button>
                    <br /><br />
                    <b>Answer Preview:</b>
                    {answers && answers.map((ans, index) => {
                        return (
                            <div style={{ marginLeft: "30px" }} key={index} className="mb-1 listing d-flex">
                                <div className="list-icon"><span onClick={() => this.removeAnswer(ans.id)}><i className="fas fa-trash text-red"></i></span></div>
                                <div className="d-flex flex-column">
                                    <label>Answer: {ans.text}</label>
                                    <label>Score: {ans.score}</label>
                                    <label>Status: {ans.status}</label>
                                    <label >Review:{this.renderRichText(ans.review)}</label>
                                    <label>Reference: <b>{ans.reference}</b></label>
                                </div>
                            </div>
                        )
                    })}
                </div>

                <div className="mt-5 row justify-content-end">
                    <button className="btn m-2 btn-outline-black" onClick={this.addQuestion.bind(this)}> <i className="fas fa-plus-circle" />{' '}Add Question</button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        addEvaluationBSuccess: state.evaluationB.addEvaluationBSuccess,
        addEvaluationBError: state.evaluationB.addEvaluationBError,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addEvaluationB: (evaluationB) => dispatch(addEvaluationB(evaluationB)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(NewSchemeQuestionnaire);